import script from "./AllChallenges.vue?vue&type=script&setup=true&lang=js"
export * from "./AllChallenges.vue?vue&type=script&setup=true&lang=js"

import "./AllChallenges.vue?vue&type=style&index=0&id=2592c1f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2592c1f0"]])

export default __exports__